import useTranslation from "@/hooks/useTranslation";
import { useCompanyImpactTotals } from "@/pages/dashboard/hooks/useCompanyImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import MetricWidget from "../../components/MetricWidget/MetricWidget";

export default function CorporateImpactTotal({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useCompanyImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  return (
    <MetricWidget
      title={"Total company footprint"}
      tooltip={translation["dashboard"]["company"]["total"]}
      metric={metric}
      loading={isLoading || isFetching}
      format={metric.formatter}
      data={{
        value: data?.company_impact[metric.key],
      }}
    />
  );
}
